// @flow

// Dms policies
const POLICY_PROGRAMS_CHANGE = 'POLICY_PROGRAMS_CHANGE';
const POLICIES_DATA_CHANGE = 'POLICIES_DATA_CHANGE';
const POLICY_DATA_CHANGE = 'POLICY_DATA_CHANGE';
const POLICY_SENT = 'POLICY_SENT';

//lpu
const LPU_DATA_CHANGES = 'lpu-data-changes';
const LPU_SELECT_OFFICE = 'lpu-select-office';

//Fetching
const FETCHING_ASSISTANCE = 'FETCHING_ASSISTANCE';
const FETCHING_FRANCHISE = 'FETCHING_FRANCHISE';
const FETCHING_TABLE_LPUS = 'FETCHING_TABLE_LPUS';
const FETCHING_SUGGESTS = 'FETCHING_SUGGESTS';
const FETCHING_CITIES = 'FETCHING_CITIES';
const FETCHING_ACCESS = 'FETCHING_ACCESS';
const FETCHING_METRO = 'FETCHING_METRO';

const FETCHING_POLICIES = 'FETCHING_POLICIES';

//rest
const VIEW_MODE_CHANGED = 'VIEW_MODE_CHANGED';

// Notifications
const NOTIFICATION_COUNT_IS_FETCHING = 'NOTIFICATION_COUNT_IS_FETCHING';
const NOTIFICATION_IS_FETCHING = 'NOTIFICATION_IS_FETCHING';
const ANSWER_IS_FETCHING = 'ANSWER_IS_FETCHING';
const SENDING_REQUEST = 'SENDING_REQUEST';
const NOTIFICATION_UPLOAD = 'NOTIFICATION_UPLOAD';
const NOTIFICATION_IS_FETCHING_WHEN_ADDING = 'NOTIFICATION_IS_FETCHING_WHEN_ADDING';

// Dms services
const FETCHING_SERVICES = 'FETCHING_SERVICES';

const ACTION = {

	//Fetching
	FETCHING_TABLE_LPUS,
	FETCHING_ASSISTANCE,
	FETCHING_FRANCHISE,
	FETCHING_SUGGESTS,
	FETCHING_CITIES,
	FETCHING_ACCESS,
	FETCHING_METRO,

	FETCHING_POLICIES,
	// Dms policies
	POLICY_PROGRAMS_CHANGE,
	POLICIES_DATA_CHANGE,
	POLICY_DATA_CHANGE,
	POLICY_SENT,

	//lpu
	LPU_DATA_CHANGES,

	//notifications
	SENDING_REQUEST,
	ANSWER_IS_FETCHING,
	NOTIFICATION_COUNT_IS_FETCHING,
	NOTIFICATION_IS_FETCHING_WHEN_ADDING,
	NOTIFICATION_IS_FETCHING,
	NOTIFICATION_UPLOAD,

	// Services
	FETCHING_SERVICES,
};

const MEDICAL_OFFICES_ACTIONS = {
	VIEW_MODE_CHANGED,
	LPU_SELECT_OFFICE,
};


export {
	ACTION,
	MEDICAL_OFFICES_ACTIONS,
};
